import bService from './base-api'
import { CONTRACT_MANAGER_URL } from '../configs/service-url'

const list = async () => {
  const url = CONTRACT_MANAGER_URL.HOTEL
  const result = await bService.get(url)

  return result
}

const create = async (data) => {
  const url = CONTRACT_MANAGER_URL.HOTEL
  const result = await bService.post(url, data)

  return result
}

const update = async (hotelId, data) => {
  const hotelUrl = CONTRACT_MANAGER_URL.HOTEL
  const url = `${hotelUrl}/${hotelId}`
  const result = await bService.put(url, data)
  return result
}

const info = async (hotelId) => {
  const hotelUrl = CONTRACT_MANAGER_URL.HOTEL
  const url = `${hotelUrl}/${hotelId}`
  const result = await bService.get(url)
  return result
}

const deleteList = async (hotelId, data) => {
  const hotelUrl = CONTRACT_MANAGER_URL.HOTEL
  const url = `${hotelUrl}/${hotelId}`
  const result = await bService.remove(url, data)

  return result
}

export default {
  list,
  create,
  update,
  info,
  deleteList
}
